import { BaseControl } from "../base-control";
// out: stdModel(epoch)

class DatetimeControlCtrl extends BaseControl {
  dtModel;
  datePickerOptions = {
    showClose: true,
    showClear: true,
    format: false,
    useCurrent: false
  }

  constructor(BaseControlService, $scope, $element) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, { $element });
  }

  async initializeControlData() {
    await super.initializeControlData();
    this.datePickerOptions.format = this.token.control.fmtDateDisplay;
    this.dtModel = this.stdModel();
    this.isPrint && this.$scope.$on('datetimepickerUpdated', _  => this.setPrintText() );
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    // Note: handle multiple instances of field
    this.dtModel = this.stdModel();
  }

  setPrintText() {
    const formattedValue = this.$element.find(`#${this.token.id}-output-value`).val();
    this.$element.find(`#${this.token.id}-output-text`).text(formattedValue);
  }
 
  // Note: on-change (dtChange) is triggered by datetimepicker directive
  dtChange(value) {
    if (!value) {
      this.stdModel(value);
      return;
    }
    const shifted = value.clone();
    const epoch = parseInt(shifted.valueOf().toString());
    this.stdModel(epoch);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/datetime-control/datetime-control.component.html",
  controller: DatetimeControlCtrl
};